var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopSoftSkills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16",
    "data-name": "Group 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.509,
    height: 87.384,
    viewBox: "0 0 84.509 87.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e68242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd4633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 84.509,
    height: 87.384,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M7.645,168.616c-.17-.048-.9-.842-.8-1.135l.01-25.808c-3.377.321-6.3-1.29-6.671-4.863.328-7.426-.51-15.333-.03-22.7a7.73,7.73,0,0,1,7.66-7.66,132.3,132.3,0,0,1,15.511,0,7.787,7.787,0,0,1,7.484,7.132c.6,7.569-.444,15.932-.026,23.583-.553,3.2-3.41,4.706-6.5,4.333l.005,25.627c.032.434-.564,1.493-.973,1.493H16.89v-22.98c0-1.164-2.817-1.379-2.817.176v22.8Z",
    transform: "translate(0 -81.231)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M276.72.092c11.647-1.4,17,13.633,7.42,19.746-8.713,5.557-19.324-3.087-16.012-12.666A11.038,11.038,0,0,1,276.72.092m4.353,6.544a1.336,1.336,0,0,0-.89.442c-.588.56-2.889,4.407-3.16,4.407-.95-2.109-3.894-1.357-2.707.949a29.19,29.19,0,0,0,2.27,2.308,1.647,1.647,0,0,0,1.852-.43l4-5.693a1.464,1.464,0,0,0-1.362-1.983",
    transform: "translate(-204.576 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M276.72,106.5c11.647-1.4,17,13.633,7.42,19.746-8.713,5.557-19.324-3.087-16.012-12.666a11.038,11.038,0,0,1,8.593-7.08m4.353,6.544a1.336,1.336,0,0,0-.89.442c-.588.56-2.889,4.407-3.16,4.407-.95-2.109-3.894-1.357-2.707.949a29.191,29.191,0,0,0,2.27,2.308,1.647,1.647,0,0,0,1.852-.43l4-5.693a1.464,1.464,0,0,0-1.362-1.983",
    transform: "translate(-204.576 -81.379)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M276.72,213.8c11.647-1.4,17,13.633,7.42,19.746-8.713,5.557-19.324-3.087-16.012-12.666a11.038,11.038,0,0,1,8.593-7.08m4.353,6.544a1.336,1.336,0,0,0-.89.442c-.588.56-2.889,4.407-3.16,4.407-.95-2.109-3.894-1.357-2.707.949a29.189,29.189,0,0,0,2.27,2.308,1.647,1.647,0,0,0,1.852-.43l4-5.693a1.464,1.464,0,0,0-1.362-1.983",
    transform: "translate(-204.576 -163.437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M35.882,15.117c12.071-1.366,13.587,16.64,2.4,17.894-12.4,1.39-13.77-16.607-2.4-17.894",
    transform: "translate(-21.496 -11.504)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M157.23,132.712l19.5-.041a1.422,1.422,0,1,1,.356,2.821H157.185a1.4,1.4,0,0,1,.045-2.779",
    transform: "translate(-119.256 -101.46)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M156.754,27.9l20.217-.042c2.059.236,1.44,2.966-.535,2.819-6.031-.436-12.906.593-18.837,0-1.927-.193-2.5-1.777-.845-2.777",
    transform: "translate(-119.136 -21.304)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M156.058,178.559c-.982-1.071.065-2.284,1.275-2.421,5.942-.674,13.12.5,19.194,0,2.079.217,2.312,2.632.007,2.824-6.147.513-12.988-.4-19.21,0a2.413,2.413,0,0,1-1.266-.406",
    transform: "translate(-119.048 -134.538)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M156.8,238.24l20.217-.042a1.341,1.341,0,0,1,.181,2.654H156.928a1.348,1.348,0,0,1-.129-2.612",
    transform: "translate(-119.18 -182.162)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M156.867,72.113l13.862-.027c1.113.023,1.353,1.986.55,2.465l-14.446.16a1.378,1.378,0,0,1,.033-2.6",
    transform: "translate(-119.248 -55.128)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M156.783,282.055c2.394.187,5.578-.387,7.876-.028a1.347,1.347,0,0,1,.183,2.627,58.209,58.209,0,0,1-7.91-.007,1.332,1.332,0,0,1-.149-2.593",
    transform: "translate(-119.164 -215.588)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopSoftSkills);
export default __webpack_public_path__ + "static/media/develop_soft_skills.8f29d56ec8fd2c61d433aa409aff37d5.svg";
export { ForwardRef as ReactComponent };